module.exports = __webpack_public_path__ + "static/media/lobby_kingmakers.ad101fd6.ad101fd6.webp";